import{useContext}from"react";import{UseNotificationsContext}from"../../contexts/use-notification.context.js";const useNotifications=()=>useContext(UseNotificationsContext)();export{useNotifications};
